export default function getShippingRate(rates, region) {
  const rate = rates?.find((rate) => rate?.region === region);

  return rate || { amount: 0 };
}
